import React, { useState } from "react";
import styles from "./styles/Sidebar.module.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import data from "../../../data/multilanguage.json";
import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { useEffect } from "react";
export function Sidebar() {
  const navigate = useNavigate();
  const auth = useAuth();
  const [isToggled, setIsToggled] = useState(false);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.pages.Sidebar
  );
  const handleToggle = () => {
    setIsToggled((prevState) => !prevState);
  };
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setContent(websiteCurrentLang.content.pages.Sidebar);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  return (
    <div className={styles.sidebar}>
      <div className={isToggled ? styles.menu_show : styles.menu_hide}>
        <div className={styles.nav_toggle} onClick={handleToggle}>
          {content.sideBarLink1}
        </div>
        <div className={styles.sidebar_menu}>
          <div
            onClick={() =>
              auth?.otp === true
                ? navigate("/user/Help-Center")
                : navigate("/Help-Center")
            }
            className={styles.link_big}
          >
            {content.sideBarLink2}
          </div>
          <div
            onClick={() =>
              auth?.otp === true
                ? navigate("/user/Help-Center/estate-planning")
                : navigate("/Help-Center/estate-planning")
            }
            className={styles.link}
          >
            {dublicatedcontent.dublicatedText7}
          </div>
          <div
            onClick={() =>
              auth?.otp === true
                ? navigate("/user/help-center/how-it-works")
                : navigate("/how-it-works")
            }
            className={styles.link}
          >
            {dublicatedcontent.dublicatedText2}
          </div>
          <div
            onClick={() =>
              auth?.otp === true
                ? navigate("/user/estate/planning")
                : navigate("/estate/planning")
            }
            className={styles.link}
          >
            {content.sideBarLink5}
          </div>
          <div
            onClick={() =>
              auth?.otp === true
                ? navigate("/user/estate/planning")
                : navigate("/estate/planning")
            }
            className={styles.link}
          >
            {content.sideBarLink6}
          </div>
          <div
            onClick={() =>
              auth?.otp === true
                ? navigate("/user/estate/planning")
                : navigate("/estate/planning")
            }
            className={styles.link}
          >
            {dublicatedcontent.dublicatedText36}
          </div>
          <div
            onClick={() =>
              auth?.otp === true
                ? navigate("/user/estate/planning")
                : navigate("/estate/planning")
            }
            className={styles.link}
          >
            {content.sideBarLink8}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
